import React from "react";
import "./loader.scss";
import { Spinner } from "reactstrap";
import { Loader as LoaderIcon } from "react-feather";


export const Loader: React.FC<{ isLoading: boolean; type?: "grow" | "spin", fullScreen?:boolean, loadingText?: string }> = ({ isLoading, children, type, fullScreen, loadingText }) => {
    return (

        <div className={`loader ${fullScreen ? 'full' : ''}`}>
            {
                isLoading && <div className="loader__overlay">
                    <div className="loader__content">
                        <LoaderIcon className="fa-spin" size={30}/>
                        {loadingText && <span className="loader__text">{loadingText}</span>}
                    </div>
                </div>
            }
            {children}
        </div>
    )
}
